import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import * as fromSidebars from '@appStore/app/reducers/siderbars.reducer';
import * as fromTips from '@appStore/app/reducers/tip.reducer';

// feature state
export interface AppState{
    sidebars: fromSidebars.State;
    tips: fromTips.State;
}

export interface State extends fromRoot.State {
  app: AppState;
}

export const reducers: ActionReducerMap<AppState> = {
  sidebars: fromSidebars.reducer,
  tips: fromTips.reducer
};

export const getState = createFeatureSelector<AppState>('app');

// Sidebars selectors
export const getSidebarsState = createSelector(
  getState,
  (state: AppState) => state.sidebars
);

export const getAnyActiveSidbars = createSelector(
  getSidebarsState,
  fromSidebars._getAnyActiveSidbars
);

// Tips selectors
export const getTipsState = createSelector(
  getState,
  (state: AppState) => state.tips
);

export const getUnreadTipsCount = createSelector(getTipsState,
  fromTips._getUnreadTipsCount);

export const getIsTipsLoaded = createSelector(getTipsState,
    fromTips._getIsTipsLoaded);

export const getIsTipsLoading = createSelector(getTipsState,
      fromTips._getIsTipsLoading);

export const getIsTipWindowOpened = createSelector(getTipsState,
  fromTips._getIsTipWindowOpened);

export const getTips = createSelector(getTipsState,
  fromTips._getTips);